import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function ScanLogs() {
  const { activeProperty } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activeProperty) return;
    setLoading(true);
    api
      .get(`/scan-logs?property_id=${activeProperty.id}&limit=500`)
      .then((r) => setRows(r.data || []))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, [activeProperty]);

  return (
    <div className="space-y-6">
      <div>
        <div className="mono-tiny text-[#71717A]">Scan logs</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-2">
          Verification history ({rows.length})
        </h1>
      </div>

      <div className="bg-white border border-[#E4E4E7] rounded-lg divide-y divide-[#E4E4E7]">
        {loading && <div className="p-6 text-sm text-[#71717A]">Loading…</div>}
        {!loading && rows.length === 0 && (
          <div className="p-6 text-sm text-[#71717A]">No scan activity yet.</div>
        )}
        {rows.map((s) => (
          <div
            key={s.id}
            className="p-4 md:p-5 flex flex-col md:flex-row md:items-center justify-between gap-2"
            data-testid={`scanlog-${s.id}`}
          >
            <div className="min-w-0">
              <div className="font-medium">{s.vehicle_summary || s.qr_code}</div>
              <div className="mono-tiny text-[#71717A] mt-1 truncate">
                {s.user_agent || "unknown client"}
              </div>
            </div>
            <div className="mono-tiny text-[#71717A] shrink-0">
              {new Date(s.scanned_at).toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
